import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FormValidation from "../../Common/FormValidation";
import Http from "../../Common/Http";
import IsLogin from "../../Common/IsLogin";
import { LoaderComponent } from "../../Common/LoaderComponent";

const Create = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({
    ticket_for: "",
    date: new Date().toISOString().slice(0, 10),
    time: new Date().toTimeString().slice(0, 8),
  });
  const [error, setError] = useState({});
  const [ticketNo, setTicketNo] = useState("");
  const [orders, setOrders] = useState([]);
  const [transfers, setTransfers] = useState([]);
  // Products available on the chosen invoice / chalan.
  const [products, setProducts] = useState([]);
  const [list, setList] = useState([{ product_id: "", qty: "" }]);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const inputInfo = [...list];

    inputInfo[index][name] = value;
    setList(inputInfo);
  };

  // Default Load
  const fetchData = () => {
    Http.get("/crm-last-ticket-no").then((res) => {
      setTicketNo(res.data);
    });
    Http.get("/order").then((res) => {
      setOrders(res.data);
    });
    Http.get("/depo-transfer").then((res) => {
      setTransfers(res.data);
    });
  };
  useEffect(() => {
    fetchData();
  }, []);
  // End Default Load

  // Switching the ticket type clears the reference and the items it filled in.
  const handleTicketForChange = (e) => {
    const value = e.target.value;
    setInputs((values) => ({ ...values, ticket_for: value, order_id: "", depo_transfer_id: "" }));
    setProducts([]);
    setList([{ product_id: "", qty: "" }]);
  };

  const handleOrderChange = (e) => {
    const value = e.target.value;
    setInputs((values) => ({ ...values, order_id: value }));
    setList([{ product_id: "", qty: "" }]);
    if (!value) return setProducts([]);
    Http.get("/crm-order-items/" + value).then((res) => {
      setProducts(res.data.map((item) => item.product).filter(Boolean));
    });
  };

  const handleTransferChange = (e) => {
    const value = e.target.value;
    setInputs((values) => ({ ...values, depo_transfer_id: value }));
    setList([{ product_id: "", qty: "" }]);
    if (!value) return setProducts([]);
    Http.get("/crm-transfer-items/" + value).then((res) => {
      setProducts(res.data.map((item) => item.product).filter(Boolean));
    });
  };

  // Add More List
  const addMoreList = () => {
    setList([...list, { product_id: "", qty: "" }]);
  };
  // Remove List
  const removeList = (index) => {
    const inputInfo = [...list];
    inputInfo.splice(index, 1);
    setList(inputInfo);
  };

  const formSubmit = () => {
    const listArr = [];
    Object.keys(list).forEach((key) => {
      listArr.push(list[key]);
    });

    inputs.items = listArr;
    inputs.ticket_no = ticketNo;
    Http.post("/crm", inputs)
      .then((res) => {
        navigate("/crm", {
          state: { message: res.data.message, type: "success" },
        });
      })
      .catch(function (e) {
        setError(e.response.data.errors ? e.response.data.errors : {});
      });
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Create Complain</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">Create Ticket Form</h6>
            <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div>

            <div className="row">
              <div className="col-lg">
                <label>
                  Ticket For <i className="fa fa-star required"></i>
                </label>
                <select className="form-control" name="ticket_for" value={inputs.ticket_for || ""} onChange={handleTicketForChange}>
                  <option value="">Select an option</option>
                  <option value="Invoice">Invoice</option>
                  <option value="Transfer Chalan">Transfer Chalan</option>
                </select>
              </div>
              <div className="col-lg">
                <label>
                  Ticket No. <i className="fa fa-star required"></i>
                </label>
                <input type="text" className="form-control" name="ticket_no" value={ticketNo || ""} onChange={(e) => setTicketNo(e.target.value)} />
              </div>
              <div className="col-lg">
                <label>
                  Date <i className="fa fa-star required"></i>
                </label>
                <input type="date" className="form-control" name="date" value={inputs.date || ""} onChange={handleChange} />
              </div>
              <div className="col-lg">
                <label>
                  Time <i className="fa fa-star required"></i>
                </label>
                <input type="time" step="1" className="form-control" name="time" value={inputs.time || ""} onChange={handleChange} />
              </div>
            </div>

            <div className="row mt-3">
              {inputs.ticket_for === "Invoice" && (
                <div className="col-lg">
                  <label>
                    Select Invoice <i className="fa fa-star required"></i>
                  </label>
                  <select className="form-control" name="order_id" value={inputs.order_id || ""} onChange={handleOrderChange}>
                    <option value="">Select Invoice</option>
                    {Array.from(orders).map((item) => (
                      <option value={item.id} key={item.id}>
                        {item.receipt_no} {item.distributor ? " - " + item.distributor.name : ""}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              {inputs.ticket_for === "Transfer Chalan" && (
                <div className="col-lg">
                  <label>
                    Select Transfer Challan <i className="fa fa-star required"></i>
                  </label>
                  <select className="form-control" name="depo_transfer_id" value={inputs.depo_transfer_id || ""} onChange={handleTransferChange}>
                    <option value="">Select Transfer Challan</option>
                    {Array.from(transfers).map((item) => (
                      <option value={item.id} key={item.id}>
                        {item.receipt_no}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              <div className="col-lg">
                <label>
                  Calling No <i className="fa fa-star required"></i>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="calling_number"
                  placeholder="Insert Number"
                  value={inputs.calling_number || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-lg">
                <label>
                  Complain Type <i className="fa fa-star required"></i>
                </label>
                <select className="form-control" name="complain_type" value={inputs.complain_type || ""} onChange={handleChange}>
                  <option value="">Select Type</option>
                  <option value="Product Damage">Product Damage</option>
                  <option value="Wrong Product Receive">Wrong Product Receive</option>
                  <option value="Net Content Shortage">Net Content Shortage</option>
                  <option value="Datecoding Mistake">Datecoding Mistake</option>
                  <option value="Damage Cartoon">Damage Cartoon</option>
                </select>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-lg">
                <label>Description</label>
                <textarea className="form-control" name="complain_message" value={inputs.complain_message || ""} onChange={handleChange}></textarea>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-10"></div>
              <div className="col-2">
                <button className="btn btn-info btn-block mg-b-10" onClick={addMoreList}>
                  <i className="fa fa-plus mg-r-10"></i> ADD More
                </button>
              </div>
              <table className="table table-sm align-items-center mb-0">
                <thead>
                  <tr>
                    <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">FG</th>
                    <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">FG Qty</th>
                    <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.from(list).map((x, i) => (
                    <tr key={i}>
                      <td>
                        <select className="form-control" name="product_id" value={x.product_id || ""} onChange={(e) => handleInputChange(e, i)}>
                          <option value="">Select FG</option>
                          {Array.from(products).map((item) => (
                            <option value={item.id} key={item.id}>
                              {item.name}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          name="qty"
                          placeholder="Insert Qty"
                          value={x.qty || ""}
                          onChange={(e) => handleInputChange(e, i)}
                        />
                      </td>
                      <td>
                        {list.length > 1 ? (
                          <button className="btn btn-danger btn-block" onClick={() => removeList(i)}>
                            <i className="fa fa-trash"></i>
                          </button>
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="row mt-3">
              <div className="col-9"></div>
              <div className="col-3">
                <button className="btn btn-primary btn-block mg-b-10" onClick={formSubmit}>
                  <i className="fa fa-send mg-r-10"></i> Create Complain
                </button>
              </div>
            </div>
          </div>
          {/* card */}
        </div>
      </div>
    </div>
  );
};

export default Create;
